import logo from "@assets/logo.png";
import { Link } from "@tanstack/react-router";
import { Button, Field } from "@web/components/ui";
import { useState } from "react";
import { joinWaitlist } from "@/features/access/api";

export default function RequestAccess() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit() {
    setError("");
    if (!email.trim()) {
      setError("Enter your email address.");
      return;
    }
    setLoading(true);
    const { error: reqError } = await joinWaitlist(email.trim(), name.trim() || undefined);
    setLoading(false);
    if (reqError) {
      setError(reqError.message);
      return;
    }
    setSubmitted(true);
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-[26rem] bg-card rounded-[1.25rem] border border-border shadow-[1px_1px_0px_0px_#1c1b2e] p-6 sm:p-8 flex flex-col gap-5">
        <div className="flex flex-col items-center gap-3 text-center">
          <img src={logo} alt="FootSlapping" className="w-16 h-16 object-contain" />
          <div>
            <span className="text-text-dim text-[0.625rem] font-bold tracking-widest uppercase">
              Invite only
            </span>
            <h1 className="text-text text-2xl font-extrabold tracking-tight mt-1">
              Request access
            </h1>
            <p className="text-text-muted text-sm mt-1">
              FootSlapping is invite-only right now. Leave your email and we'll let you know when a
              spot — or a friend's invite — opens up.
            </p>
          </div>
        </div>

        {submitted ? (
          <div className="flex flex-col items-center gap-2 text-center py-4">
            <span className="text-3xl" role="img" aria-label="Success">
              🎉
            </span>
            <p className="text-text font-bold">You're on the list!</p>
            <p className="text-text-muted text-sm">
              We'll email you at <span className="font-semibold">{email.trim()}</span> if a spot
              opens up. Already have an invite code?{" "}
              <Link to="/sign-up" className="text-aqua font-extrabold no-underline hover:underline">
                Sign up now
              </Link>
            </p>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              void handleSubmit();
            }}
            className="flex flex-col gap-4"
          >
            <Field label="Name" value={name} onChangeText={setName} placeholder="Your name" />
            <Field
              label="Email"
              value={email}
              onChangeText={setEmail}
              placeholder="you@example.com"
              type="email"
            />
            {error ? (
              <p className="text-coral text-xs font-semibold" role="alert">
                {error}
              </p>
            ) : null}
            <Button
              type="submit"
              label={loading ? "Joining..." : "Join the waitlist"}
              disabled={loading}
            />
          </form>
        )}

        <p className="text-text-muted text-xs text-center">
          Have an invite code?{" "}
          <Link to="/sign-up" className="text-aqua font-extrabold no-underline hover:underline">
            Sign up
          </Link>{" "}
          &middot; Already a member?{" "}
          <Link to="/sign-in" className="text-aqua font-extrabold no-underline hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
